export enum UserStatus {
  CREATED = 'CREATED',
  REGISTERED = 'REGISTERED',
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  PASSWORD_RESTORED = 'PASSWORD_RESTORED',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
}
